module.exports = __webpack_public_path__ + "static/media/tutorial-02.e516c657.jpg";